var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pdf-document",class:{'cursor-pointer': !_vm.isMaximized},attrs:{"id":"pdf-content"},on:{"click":function($event){$event.stopPropagation();return _vm.$emit('maximize')}}},_vm._l((_vm.pages),function(page){return _c('PDFPage',{key:page.pageNumber,attrs:{"scale":_vm.scale,"page":page}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }